/*
The GlobalEvents object only has an instance for all the application.
This object lets register event methods using a string key. 
The event methods are stored in a map with the key as the event name.
The event methods are called using the key.
Every other object around the application can register and call events using this object.
*/

class GlobalEvents {
    private static instance: GlobalEvents;
    private events: Map<string, Function>;

    private constructor() {
        this.events = new Map<string, Function>();
    }

    public static getInstance(): GlobalEvents {
        if (!GlobalEvents.instance) {
            GlobalEvents.instance = new GlobalEvents();
        }

        return GlobalEvents.instance;
    }

    public registerEvent(eventName: string, eventMethod: Function): void {
        if (this.events.has(eventName)) {
            this.events.delete(eventName);
        }

        this.events.set(eventName, eventMethod);
    }

    public callEvent(eventName: string, ...args: any[]) {
        try {
            if (!this.events.has(eventName)) {
                return;
            }

            return (this.events.get(eventName) as Function)(...args);
        } catch (error) {
            console.error("GlobalEvents.callEvent -> eventName: '", eventName, "'", error);
            throw error;
        }
    }

    public async callAsyncEvent(eventName: string, ...args: any[]) {
        try {
            if (!this.events.has(eventName)) {
                return;
            }

            return await (this.events.get(eventName) as Function)(...args);
        } catch (error) {
            console.error("GlobalEvents.callAsyncEvent -> eventName: '", eventName, "'", error);
            throw error;
        }
    }
}

const globalEvents = GlobalEvents.getInstance();

export default globalEvents;
